document.addEventListener('DOMContentLoaded', function () {

    document.querySelector('#length')?.focus()
  
    document.querySelector("#width")?.addEventListener('keypress', function (e) {
      if (e.keyCode == 13) {
        // detect the enter key
        calculate();
      }
    });
  
    document.querySelector("#diameter")?.addEventListener('keypress', function (e) {
      if (e.keyCode == 13) {
        // detect the enter key
        calculate();
      }
    });
  
    document.querySelector(".calcInput")?.blur(function(e) {
      this.value = sanitizeInput(this);
    });
    
    document.querySelector("#btnCalculate")?.addEventListener('click', function(){calculate()});

   document.querySelector("#shape").addEventListener('change', function(elm){
      if(elm.target.value == 'circ') {
        document.querySelector('.diameter-wrap').style.display = "flex"
        document.querySelectorAll('.length-wrap').forEach(elm => {
          elm.style.display = 'none'
        })
      } else {
        document.querySelector('.diameter-wrap').style.display = "none"
        document.querySelectorAll('.length-wrap').forEach(elm => {
          elm.style.display = 'flex'
        })
      }
    })
  
    function sanitizeInput(el) {
      return parseInt(el.value,10) > 0 ? parseInt(el.value,10) : "";
    }
    
    function formatGallonsAndOuncesWithRatio(resinOz, hardenerOz) {
      // Ensure minimum values of 0.5 oz for very small amounts
      if (hardenerOz < 0.25) {
        hardenerOz = 0.5;
        resinOz = 1;
      }
      
      // First, round the hardener to nearest 0.5
      const hardenerRounded = Math.round(hardenerOz * 2) / 2;
      // Then calculate resin as exactly 2x the hardener to maintain 2:1 ratio
      const resinRounded = hardenerRounded * 2;
      
      // Format resin
      const resinGallons = Math.floor(resinRounded / 128);
      let resinRemainingOz = resinRounded % 128;
      
      // Round ounces to whole numbers if >= 1 gallon
      if (resinGallons >= 1) {
        resinRemainingOz = Math.round(resinRemainingOz);
      }
      
      let resinDisplay;
      
      if (resinGallons > 0 && resinRemainingOz > 0) {
        const gallonText = resinGallons === 1 ? 'Gallon' : 'Gallons';
        const ounceText = resinRemainingOz === 1 ? 'Ounce' : 'Ounces';
        const ozDisplay = resinGallons >= 1 ? resinRemainingOz.toFixed(0) : (resinRemainingOz % 1 === 0 ? resinRemainingOz.toFixed(0) : resinRemainingOz.toFixed(2));
        resinDisplay = `${resinGallons} ${gallonText}, ${ozDisplay} ${ounceText}`;
      } else if (resinGallons > 0) {
        const gallonText = resinGallons === 1 ? 'Gallon' : 'Gallons';
        resinDisplay = `${resinGallons} ${gallonText}`;
      } else {
        const ounceText = resinRounded === 1 ? 'Ounce' : 'Ounces';
        resinDisplay = resinRounded < 1 ? `${resinRounded.toFixed(2)} ${ounceText}` : `${resinRounded} ${ounceText}`;
      }
      
      // Format hardener
      const hardenerGallons = Math.floor(hardenerRounded / 128);
      let hardenerRemainingOz = hardenerRounded % 128;
      
      // Round ounces to whole numbers if >= 1 gallon
      if (hardenerGallons >= 1) {
        hardenerRemainingOz = Math.round(hardenerRemainingOz);
      }
      
      let hardenerDisplay;
      
      if (hardenerGallons > 0 && hardenerRemainingOz > 0) {
        const gallonText = hardenerGallons === 1 ? 'Gallon' : 'Gallons';
        const ounceText = hardenerRemainingOz === 1 ? 'Ounce' : 'Ounces';
        const ozDisplay = hardenerGallons >= 1 ? hardenerRemainingOz.toFixed(0) : (hardenerRemainingOz % 1 === 0 ? hardenerRemainingOz.toFixed(0) : hardenerRemainingOz.toFixed(2));
        hardenerDisplay = `${hardenerGallons} ${gallonText}, ${ozDisplay} ${ounceText}`;
      } else if (hardenerGallons > 0) {
        const gallonText = hardenerGallons === 1 ? 'Gallon' : 'Gallons';
        hardenerDisplay = `${hardenerGallons} ${gallonText}`;
      } else {
        const ounceText = hardenerRounded === 1 ? 'Ounce' : 'Ounces';
        hardenerDisplay = hardenerRounded < 1 ? `${hardenerRounded.toFixed(2)} ${ounceText}` : `${hardenerRounded} ${ounceText}`;
      }
      
      return {
        resin: resinDisplay,
        hardener: hardenerDisplay
      };
    }
    
    function formatLitersAndMillilitersWithRatio(resinMl, hardenerMl) {
      // For very small amounts, ensure we show at least 1ml
      if (hardenerMl < 0.5) {
        hardenerMl = 1;
        resinMl = 2;
      }
      
      // Round the hardener based on amount
      let hardenerRounded;
      if (hardenerMl < 10) {
        // For very small amounts, round to nearest 1ml
        hardenerRounded = Math.round(hardenerMl);
      } else if (hardenerMl < 100) {
        // For small amounts, round to nearest 5ml
        hardenerRounded = Math.round(hardenerMl / 5) * 5;
      } else if (hardenerMl < 1000) {
        // For medium amounts, round to nearest 50ml
        hardenerRounded = Math.round(hardenerMl / 50) * 50;
      } else {
        // For large amounts, round to nearest 100ml
        hardenerRounded = Math.round(hardenerMl / 100) * 100;
      }
      
      // Ensure minimum of 1ml
      if (hardenerRounded < 1) hardenerRounded = 1;
      
      // Then calculate resin as exactly 2x the hardener to maintain 2:1 ratio
      const resinRounded = hardenerRounded * 2;
      
      // Format resin
      const resinLiters = Math.floor(resinRounded / 1000);
      const resinRemainingMl = Math.round(resinRounded % 1000);
      let resinDisplay;
      
      if (resinLiters > 0 && resinRemainingMl > 0) {
        const literText = resinLiters === 1 ? 'Liter' : 'Liters';
        const mlText = resinRemainingMl === 1 ? 'Milliliter' : 'Milliliters';
        resinDisplay = `${resinLiters} ${literText}, ${resinRemainingMl} ${mlText}`;
      } else if (resinLiters > 0) {
        const literText = resinLiters === 1 ? 'Liter' : 'Liters';
        resinDisplay = `${resinLiters} ${literText}`;
      } else {
        const mlText = resinRounded === 1 ? 'Milliliter' : 'Milliliters';
        resinDisplay = `${Math.round(resinRounded)} ${mlText}`;
      }
      
      // Format hardener
      const hardenerLiters = Math.floor(hardenerRounded / 1000);
      const hardenerRemainingMl = Math.round(hardenerRounded % 1000);
      let hardenerDisplay;
      
      if (hardenerLiters > 0 && hardenerRemainingMl > 0) {
        const literText = hardenerLiters === 1 ? 'Liter' : 'Liters';
        const mlText = hardenerRemainingMl === 1 ? 'Milliliter' : 'Milliliters';
        hardenerDisplay = `${hardenerLiters} ${literText}, ${hardenerRemainingMl} ${mlText}`;
      } else if (hardenerLiters > 0) {
        const literText = hardenerLiters === 1 ? 'Liter' : 'Liters';
        hardenerDisplay = `${hardenerLiters} ${literText}`;
      } else {
        const mlText = hardenerRounded === 1 ? 'Milliliter' : 'Milliliters';
        hardenerDisplay = `${Math.round(hardenerRounded)} ${mlText}`;
      }
      
      return {
        resin: resinDisplay,
        hardener: hardenerDisplay
      };
    }
    
    function calculate() {
  
      var lengthData = document.querySelector("#length")?.value;
      var widthData = document.querySelector("#width")?.value;
      var diameterData = document.querySelector("#diameter")?.value;
      var shapeType = document.querySelector("#shape")?.value;
      var unitType = document.querySelector("#units").value;
  
      if (unitType == "cm") {
        lengthData = lengthData / 2.54;
        widthData = widthData / 2.54;
        diameterData = diameterData / 2.54;
      }
  
      var fixValue = 0.0625;
      var dividedBy = 231;
      var cal, result;
  
  
      if (shapeType == "circ") {
        if (!!diameterData) {
          cal = Math.pow((diameterData/2), 2) * Math.PI * fixValue;
          result = cal / dividedBy;
        } else {
          alert("Please enter a Diameter to calculate.");
          return;
        }
      }
  
      if (shapeType == "rect") {
        if (!!lengthData && !!widthData) {
          cal = lengthData * widthData * fixValue;
          result = cal / dividedBy;
        } else {
          alert("Please enter Length and Width to calculate.");
          return;
        }
      }
  
      if (!!result) {
        
        var resultOz = result * 128;
        var resultLt = result * 3.78541;
        var resultMl = result * 3785.41;
        
        console.log("gal: " + result, "oz: " + resultOz, "l: " + resultLt, "ml: " + resultMl);
  
        var getResult = result.toFixed(2);
        
        // For 2:1 ratio, the TOTAL amount should be split as:
        // Resin = 2/3 of total (which becomes "2 parts")
        // Hardener = 1/3 of total (which becomes "1 part")
        // This way, resin:hardener = 2:1
        
        var resinGal = parseFloat(getResult) * 2 / 3;
        var hardenerGal = parseFloat(getResult) / 3;
        
        var resinOz = resultOz * 2 / 3;
        var hardenerOz = resultOz / 3;
        
        var resinMl = resultMl * 2 / 3;
        var hardenerMl = resultMl / 3;
        
        console.log("Calculated amounts - Resin oz:", resinOz, "Hardener oz:", hardenerOz);
        console.log("Calculated amounts - Resin ml:", resinMl, "Hardener ml:", hardenerMl);
        
        // Show/hide appropriate wrappers based on units
        if (unitType == "in") {
          // Show ounces wrapper, hide gal wrapper
          document.querySelectorAll('.onces-wrapper').forEach(elm => {
            elm.style.display = 'block';
          });
          document.querySelectorAll('.gal-wrapper').forEach(elm => {
            elm.style.display = 'none';
          });
          
          // Format and display results maintaining 2:1 ratio
          const formattedAmounts = formatGallonsAndOuncesWithRatio(resinOz, hardenerOz);
          document.querySelector('#resin-oz').innerHTML = formattedAmounts.resin;
          document.querySelector('#hardener-oz').innerHTML = formattedAmounts.hardener;
          
        } else if (unitType == "cm") {
          // Hide ounces wrapper, show gal wrapper (but use it for L/ml)
          document.querySelectorAll('.onces-wrapper').forEach(elm => {
            elm.style.display = 'none';
          });
          document.querySelectorAll('.gal-wrapper').forEach(elm => {
            elm.style.display = 'block';
          });
          
          // Format and display results maintaining 2:1 ratio for metric
          const formattedAmounts = formatLitersAndMillilitersWithRatio(resinMl, hardenerMl);
          document.querySelector('#resin-gal').innerHTML = formattedAmounts.resin;
          document.querySelector('#hardener-gal').innerHTML = formattedAmounts.hardener;
        }
        
        // Update the old display values (keeping for compatibility) - only if elements exist
        if (document.querySelector("#calcgall")) {
          document.querySelector("#calcgall").innerHTML = getResult + " Gallons";
        }
        if (document.querySelector("#calcoz")) {
          const ounceText = resultOz === 1 ? 'Ounce' : 'Ounces';
          document.querySelector("#calcoz").innerHTML = resultOz.toFixed(0) + ` ${ounceText}`;
        }
        if (document.querySelector("#calclt")) {
          document.querySelector("#calclt").innerHTML = resultLt.toFixed(2) + " Liters";
        }
        if (document.querySelector("#calcml")) {
          const mlText = resultMl === 1 ? 'Milliliter' : 'Milliliters';
          document.querySelector("#calcml").innerHTML = resultMl.toFixed(0) + ` ${mlText}`;
        }
        if (document.querySelector('#resin-ml')) {
          document.querySelector('#resin-ml').innerHTML = resinMl.toFixed(2);
        }
        if (document.querySelector('#hardener-ml')) {
          document.querySelector('#hardener-ml').innerHTML = hardenerMl.toFixed(2);
        }
  
        //******************************************
        //scan products and find bottle volume (oz or gal amount)
  
        var productValues = [];
        var productCount = 0;
  
        document.querySelectorAll(".product").forEach(function (el) {
          console.log(el.dataset.volume)
          var bottleVolume = 0;
          var productName = el.querySelector("h3.card-information__text.h5").innerText;
          var productVolume = el.dataset.volume
          var productId = el.getAttribute("id");
  
          if (el.dataset.volume.indexOf("oz") >= 0) {
            bottleVolume = +productVolume.replace("oz", "");
            console.log("bottleVolume", bottleVolume)
            //convert to gal
            if (bottleVolume > 0) {
              bottleVolume = bottleVolume / 128;
            }
          } else if (el.dataset.volume.indexOf("gal") >= 0) {
            bottleVolume = +productVolume.replace("gal", "");
          }
  
          productValues[productCount] = [
            productId,
            parseFloat(bottleVolume),
            productName,
          ];
  
          //hide all products during scan
          document.querySelector("#" + productValues[productCount][0]).style.display = "none";
  
          productCount++;
        });
  
        //sort products array by bottle volume
        productValues.sort(function (a, b) {
          if (a[1] == b[1]) {
            return 0;
          }
          if (a[1] > b[1]) {
            return 1;
          } else {
            return -1;
          }
        });
  
        //find and show matching product
        console.log(productValues)
        var productToShow = null;
        
        if (productValues.length > 0) {
          if (getResult <= productValues[0][1]) {
            // If needed amount is less than smallest product, show smallest
            productToShow = productValues[0];
          } else if (getResult > productValues[productValues.length - 1][1]) {
            // If needed amount is more than largest product, show largest
            console.log('Amount needed exceeds all products, showing largest available');
            productToShow = productValues[productValues.length - 1];
          } else {
            // Find the appropriate product in between
            for (var i = 1; i < productValues.length; i++) {
              if (getResult >= productValues[i - 1][1] && getResult <= productValues[i][1]) {
                productToShow = productValues[i];
                break;
              }
            }
          }
          
          // Display the selected product
          if (productToShow) {
            let resinPart = productToShow[1] * 2 / 3;
            let hardenerPart = productToShow[1] / 3;
            
            if (document.querySelector('#hardener-volume-needed')) {
              document.querySelector('#hardener-volume-needed').innerHTML = hardenerPart.toFixed(2);
            }
            if (document.querySelector('#hardener-sq-ft')) {
              document.querySelector('#hardener-sq-ft').innerHTML = (hardenerPart * 32).toFixed(0);
            }
            if (document.querySelector('#resin-volume-needed')) {
              document.querySelector('#resin-volume-needed').innerHTML = resinPart.toFixed(2);
            }
            if (document.querySelector('#resin-sq-ft')) {
              document.querySelector('#resin-sq-ft').innerHTML = (resinPart * 32).toFixed(0);
            }
            document.querySelector("#" + productToShow[0]).style.display = "flex";
          }
        }
        
        document.querySelector(".calculatorproducts").style.display = "block";
        document.querySelector(".calculator-message").style.display = "block";
  
      } else {
        alert("Please confirm that you have entered dimensions properly.");
      }
    }
  
  });